/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React, { useEffect, useState } from 'react'
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { ERR_INVALID_URL, WEBHOOK_SECRET,WEBHOOK_SECRET_VALUE, WEBHOOK_NAME, WEBHOOK_URL, WEBHOOK_NAME_ERROR, WEBHOOK_NAME_INVALID, WEBHOOK_SECRET_KEY_INVALID, WEBHOOK_SECRET_VALUE_INVALID, LABEL_BTN_CANCEL } from 'src/constants/constant';
import { InputAdornment, TextField } from '@mui/material';
import { getAllWebhookConfigById, updateWebhookConfig } from 'src/services/webhookconfigService';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { NotificationManager } from 'react-notifications';
import '../Styles/muiglobal.css';

import { useSelector } from 'react-redux';
import type { RootState, EditWebhookFormInputs } from '../types/types';
import { checkEventPermission } from 'src/common/utility/utility';

// import MainLayout from '../Layouts/Mainlayout';

interface PropsType {
    id?: number;
}

interface PropsType {
    closeModal: () => void;
    refreshPage: () => void;
}

interface ApiResponse {
    status: number;
    data: {
        data: EditWebhookFormInputs;
    };
}

interface EditApiResponse {
    status: number;
    data: {
        result: number;
        messages: string;
    };
    
}


const validationSchema = Yup.object().shape({
    webhookName: Yup.string().required(WEBHOOK_NAME_ERROR).matches(/^\S.*\S$|^\S$/, WEBHOOK_NAME_INVALID),
    url: Yup.string().required('Please enter the webhook URL').matches(
            /^((http|https):\/\/)?(www\.)?(?!.*(http|https|www\.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+(\/)?.([\w\?[a-zA-Z-_%\/@?]+)*([^\/\w\?[a-zA-Z0-9_-]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?(\?.*)?$/gm,
            ERR_INVALID_URL
        ),
    SecretKey: Yup.string().matches(/^$|^\S(.*\S)?$/, WEBHOOK_SECRET_KEY_INVALID),
    SecretValue: Yup.string().matches(/^$|^\S(.*\S)?$/, WEBHOOK_SECRET_VALUE_INVALID),
});


const EditWebhookForm = ({ id, closeModal, refreshPage }: PropsType): JSX.Element => {

    const [webhookData, setWebhookData] = useState<EditWebhookFormInputs>()
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const { user } = useSelector((state: RootState) => state.auth);
    const [isEditing, setIsEditing] = useState(false);

    const {
        control,
        handleSubmit,
        formState: { errors },
        setValue
    } = useForm<EditWebhookFormInputs>({
        resolver: yupResolver(validationSchema),
        mode: 'onSubmit',
    });

    useEffect(() => {
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        const fetchWebhookData = async () => {
            try {
                const editWebhookIdNumber = id;
                if (editWebhookIdNumber == null) return;
                setIsLoading(true)
                const res: ApiResponse = await getAllWebhookConfigById(editWebhookIdNumber);
                // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                if (res.status === 200 && res.data.data) {
                    const webhook = res.data.data;
                    setWebhookData(webhook);
                    
                    // Set form values
                    setValue("webhookName", webhook.webhookName);
                    setValue("url", webhook.url);
                    setValue("secretKey", webhook.secretKey);
                    setValue("secretValue", webhook.secretValue);
                }
            } catch (error) {
                console.error("Error fetching webhook data:", error);
                NotificationManager.error("Error loading webhook data");
            } finally {
                setIsLoading(false)
            }
        };

        void fetchWebhookData();
    }, [id, setValue]);

    const onSubmit = async (data: EditWebhookFormInputs): Promise<void> => {

        data.id = id;
        data.updatedBy =  user?.id ?? 0;
        data.clientId = user?.clientId ?? 0;
        data.isActive = 1;
        data.isDeleted = 0;
        console.log(data);
        setIsLoading(true)
        await updateWebhookConfig(data)
            .then(
                (res: EditApiResponse) => {
                    if (res.status === 200 ) {
                        if(res.data.result === 1) {
                            NotificationManager.success("Webhook updated successfully")
                            refreshPage()
                        } else {
                                NotificationManager.error("Unknown error has occurred")
                        }
                    }
                }
            )
            .catch(
                error => {
                    console.log("error", error)
                    NotificationManager.error("Unknown error has occurred")
                }
            )
            .finally(() => {
                setIsLoading(false)
            })
    }

    const handleEditWebhook = ():void => {
        setIsEditing(true);
    }

    return (
        <React.Fragment>
            {
                isLoading ?
                    <div className='flex justify-center items-center relative '><span className="loading loading-spinner text-primary"></span></div> :
                    <form onSubmit={(e) => {e.preventDefault(); void handleSubmit(onSubmit)(e);}}>
                        <div className="px-[16px] pt-[10px]">
                            <div className="grid">
                                <div className={`mb-[5px] w-full relative role-input-container ${!isEditing ? 'disabled' : ''}`} style={{ marginBottom: '30px' }}>
                                    <div >
                                        <Controller
                                            name="webhookName"
                                            control={control}
                                            defaultValue={webhookData?.webhookName}
                                            render={({ field }) => (
                                                <TextField
                                                    {...field}
                                                    fullWidth
                                                    label="Webhook Name"
                                                    autoComplete="off"
                                                    placeholder={WEBHOOK_NAME}
                                                    // value={field.value}
                                                    error={Boolean(errors.webhookName)}
                                                    helperText={errors.webhookName?.message}
                                                    InputProps={{
                                                        style: {
                                                            textAlign: "center",
                                                            color: '#343434',
                                                            fontSize: '18px',
                                                            fontWeight: '700',
                                                            WebkitTextFillColor: '#343434',
                                                            padding: '9px 14px 9px 25px',
                                                        },
                                                        placeholder: `${WEBHOOK_NAME}`,
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                <div className="btn btn-circle btn-circle-small bg-[#fff] hover:bg-[#f5f5f5] border-0 ml-2" style={{ padding: '4px', width: '2rem', height: '2rem', minHeight: '2rem' }} onClick={handleEditWebhook}>
                                                                    <img src={'/assets/images/icons/EditIcon.svg'} width={15} height={15} alt="Edit" />
                                                                </div>
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                    sx={{
                                                        '& input': {
                                                            textAlign: 'center',
                                                        },
                                                        '& label': {
                                                            textAlign: 'center',
                                                        },
                                                    }}
                                                    disabled={!isEditing}
                                                />
                                            )}
                                        />
                                    </div> 
                                </div>
                                <div className="mb-[30px]">
                                    <Controller
                                        name="url"
                                        control={control}
                                        defaultValue={webhookData?.url}
                                        render={({ field }) => (
                                        <>
                                            <TextField
                                            label="Webhook URL"
                                            {...field}
                                            fullWidth
                                            autoComplete="off"
                                            InputProps={{
                                                inputProps: {
                                                style: {
                                                    textAlign: "left",
                                                    color: '#343434',
                                                    fontSize: '18px',
                                                    fontWeight: '700',
                                                    WebkitTextFillColor: '#343434',
                                                    padding: '9px 14px',
                                                },
                                                placeholder: `${WEBHOOK_URL}`,
                                                },
                                            }}
                                            sx={{
                                                "& label": {
                                                textAlign: "center",
                                                },
                                                backgroundColor: "#F5F5F5",
                                            }}
                                            error={!!errors.url} // Set error state based on form validation
                                            placeholder={WEBHOOK_URL}
                                            />
                                            {errors.url && (
                                            <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                                {errors.url?.message} 
                                            </div>
                                            )}
                                        </>
                                        )}
                                    />
                                </div>
                                <div className="mb-[30px]">
                                    <Controller
                                        name="secretKey"
                                        control={control}
                                        defaultValue={webhookData?.secretKey}
                                        render={({ field }) => (
                                        <>
                                            <TextField
                                            {...field}
                                            label="Secret Key"
                                            fullWidth
                                            autoComplete="off"
                                            InputProps={{
                                                inputProps: {
                                                style: {
                                                    textAlign: "left",
                                                    color: '#343434',
                                                    fontSize: '18px',
                                                    fontWeight: '700',
                                                    WebkitTextFillColor: '#343434',
                                                    padding: '9px 14px',
                                                },
                                                placeholder: `${WEBHOOK_SECRET}`,
                                                },
                                            }}
                                            sx={{
                                                "& label": {
                                                textAlign: "center",
                                                },
                                                backgroundColor: "#F5F5F5",
                                            }}
                                            error={!!errors.secretKey} // Set error state based on form validation
                                            placeholder={WEBHOOK_SECRET}
                                            />
                                            {errors.secretKey && (
                                            <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                                {errors.secretKey?.message} {/* Show the error message */}
                                            </div>
                                            )}
                                        </>
                                        )}
                                    />
                                </div>
                                <div className="mb-[30px]">
                                    <Controller
                                        name="secretValue"
                                        control={control}
                                        defaultValue={webhookData?.secretValue}
                                        render={({ field }) => (
                                        <>
                                            <TextField
                                            {...field}
                                            label="Secret Value"
                                            fullWidth
                                            autoComplete="off"
                                            InputProps={{
                                                inputProps: {
                                                style: {
                                                    textAlign: "left",
                                                    color: '#343434',
                                                    fontSize: '18px',
                                                    fontWeight: '700',
                                                    WebkitTextFillColor: '#343434',
                                                    padding: '9px 14px',
                                                },
                                                placeholder: `${WEBHOOK_SECRET_VALUE}`,
                                                },
                                            }}
                                            sx={{
                                                "& label": {
                                                textAlign: "center",
                                                },
                                                backgroundColor: "#F5F5F5",
                                            }}
                                            error={!!errors.secretValue} // Set error state based on form validation
                                            placeholder={WEBHOOK_SECRET_VALUE}
                                            />
                                            {errors.secretValue && (
                                            <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                                {errors.secretValue?.message} {/* Show the error message */}
                                            </div>
                                            )}
                                        </>
                                        )}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="grid grid-cols-6 gap-0 fixed bottom-0 w-[100%] z-10 bg-white">
                            <div className="w-full relative col-span-3">
                                <button type='button' className="btn btn-block bg-white font-semibold capitalize border-1 border-[#D9D9D9] rounded-none text-14 text-muted w-full hover:bg-[#ccc] hover:border-[#D9D9D9] disabled:bg-[#f0f0f0] disabled:text-muted" disabled={isLoading} onClick={closeModal}>{LABEL_BTN_CANCEL}</button>
                            </div>
                            <div className="w-full relative col-span-3">
                                <button type="submit" className="btn btn-block bg-gradient-to-b btn-primary from-[#ED4B52] to-[#D6242C] h-[45px] text-14 focus-visible:outline-none rounded-none font-semibold text-white disabled:btn-primary disabled:opacity-100 disabled:text-white capitalize hover:from-[#D6242C] hover:to-[#ED4B52]" disabled={isLoading || !checkEventPermission('WEBHOOKS_UPDATE')}>{!isLoading ? 'Save' : <span className="loading loading-spinner loading-xs text-white"></span>}</button>
                            </div>
                        </div>
                    </form>
            }
        </React.Fragment>

    )
}

export default EditWebhookForm